














import { Component, Prop, Vue } from 'vue-property-decorator';
import { Person } from '@/models/Person';
import { Slot } from '@/models/CalendarEntries';
import PersonItem from '@/components/Retailer/BookingCalendar/PersonItem.vue';
@Component({
  components: {
    PersonItem
  },
})
export default class PersonList extends Vue {
  @Prop() private persons!: Person[];
  @Prop() private selectedSlots!: Slot[];
}
